import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from '../../service/common.service';
import { DebriefProfileTimerService } from '../../service/debrief-profile-timer.service';

/**
 * Banner shown while the IQIGAI Buddy (debrief bot) completion status is being
 * fetched. Driven by the shared DebriefProfileTimerService so the same single
 * timer is displayed on the dashboard-assessment and my-profile pages.
 */
@Component({
  selector: 'app-buddy-status-banner',
  templateUrl: './buddy-status-banner.component.html',
  standalone: false,
})
export class BuddyStatusBannerComponent implements OnInit, OnDestroy {
  /**
   * 'dashboard': when the timer ends, the banner turns green and shows the
   *   "View Updated Profile" button.
   * 'profile': when the timer ends, `timerEnded` is emitted (the profile page
   *   refreshes the status via get-basic-details) and the banner hides.
   */
  @Input() context: 'dashboard' | 'profile' = 'dashboard';
  /** Extra classes on the banner wrapper (e.g. top offset below the fixed header). */
  @Input() topOffsetClass: string = '';
  @Output() timerEnded = new EventEmitter<void>();

  private stateSub: Subscription;
  private endedEmitted = false;

  constructor(
    public profileTimer: DebriefProfileTimerService,
    private readonly router: Router,
    private readonly commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.stateSub = this.profileTimer.state$.subscribe((state) => {
      if (
        state === 'ended' &&
        this.context === 'profile' &&
        !this.endedEmitted
      ) {
        this.endedEmitted = true;
        this.timerEnded.emit();
      }
    });
  }

  get showRunningBanner(): boolean {
    return this.profileTimer.isRunning;
  }

  get showEndedBanner(): boolean {
    return this.context === 'dashboard' && this.profileTimer.isEnded;
  }

  viewUpdatedProfile(): void {
    this.router.navigate([this.commonService.Navigations.MYPROFILE]);
  }

  ngOnDestroy(): void {
    this.stateSub?.unsubscribe();
  }
}
